function Product() {
	var sideNav = document.getElementById('tabs');
	var prodList = document.getElementById('info');

	var scrolled = false;

	window.addEventListener('scroll', function() {
		scrolled = true;

		setTimeout(function() {
			scrolled = false;
		}, 500);
	});

	var offsetTop = sideNav ? getOffsetTop(sideNav) : 0;
	var links = sideNav ? sideNav.getElementsByTagName('a') : [];

	var listings = [];

	for (var i = 0; i < links.length; i++) {
		var anchor = links[i].href.split('#');
		anchor = anchor[anchor.length - 1];
		listings.push(document.getElementById(anchor));

		links[i].addEventListener('click', function(e) {
			e.preventDefault();
			var id = e.target.href.split('#');
			id = id[id.length - 1];
			scrollToY(getOffsetTop(document.getElementById(id)) - 70, 1000, 'easeInOutQuint');
		});
	}

	var bookDiv = document.getElementById('book');

	function scrollEvents() {
		if (scrolled && document.body.clientWidth > 768) {
			var st = document.body.scrollTop + document.documentElement.scrollTop;

			if (sideNav) {
				if (st > offsetTop - 77) {
					sideNav.classList.add('fixed');
					prodList.classList.add('fixed');

					if (st > (getOffsetTop(bookDiv) - getCSS('height', bookDiv)) - 120) {
						sideNav.classList.add('atBottom');
					} else {
						sideNav.classList.remove('atBottom');
					}
				} else {
					sideNav.classList.remove('fixed');
					prodList.classList.remove('fixed');
				}

				for (var l = 0; l < listings.length; l++) {
					if (st > getOffsetTop(listings[l]) - 160) {
						var id = listings[l].id;

						for (var ll = 0; ll < links.length; ll++) {
							var href = links[ll].href.split('#');
							href = href[href.length - 1];

							if (href !== id) {
								links[ll].classList.remove('active');
							} else {
								links[ll].classList.add('active');
							}
						}
					}
				}
			}

		}
		requestAnimationFrame(scrollEvents);
	}

	scrollEvents();
}

function getOffsetTop(elem) {
	var offsetTop = 0;
	do {
		if (!isNaN(elem.offsetTop)) {
			offsetTop += elem.offsetTop;
		}
	} while (elem = elem.offsetParent);
	return offsetTop;
}

window.Product = Product;
